module.exports = __webpack_public_path__ + "js/0.e9f5e4bd.worker.js"